// Mirrors Finkit.Tenants.User.TraderSurveillance.Templates contracts
// (TsAlertTemplateAppService). The templates are host-managed "predefined"
// alert profile templates surfaced on the host admin page.

// Finkit.Needs enums — numeric values are the wire contract, do not renumber.
export enum TsAlertProfileType {
  AccountConditions = 0,
  ClosedTrades = 1,
  Deals = 2,
}

export enum TsTradeSession {
  NotApplicable = 0,
  Sydney = 1,
  Tokyo = 2,
  London = 3,
  NewYork = 4,
  Custom = 5,
}

export enum TsComparisonOperator {
  NotApplicable = 0,
  GreaterThan = 1,
  SmallerThan = 2,
  EqualTo = 3,
}

export enum MiFIDClassification {
  Retail = 0,
  PerSeProfessional = 1,
  ProfessionalOnRequest = 2,
  EligibleCounterparty = 3,
  Default = 4,
}

// TsReason — NotApplicable (-1) is excluded from the filter dropdown.
export enum TsReason {
  Client = 0,
  Expert = 1,
  Dealer = 2,
  Signal = 10,
  Mobile = 16,
  Web = 17,
}

// Create/Update body (CreateUpdateTsAlertTemplateInput). Priority is the string
// display name ("Low"|"Medium"|"High"); reportingCurrency is always true on host.
export interface CreateUpdateTsAlertTemplateInput {
  profileTag: string;
  priority?: string | null;
  historyDate: string; // YYYY-MM-DD
  type?: TsAlertProfileType | null;
  tradeSession?: TsTradeSession | null;
  tradeTime?: number | null;
  tradePoints?: number | null;
  cumulativeProfitThresholds: boolean;
  cumulativeProfitThresholdsAmount?: number | null;
  cumulativeProfitThresholdsFloating: boolean;
  profitThresholdsPerTrade: boolean;
  profitThresholdsAmountPerTrade?: number | null;
  volume?: number | null;
  volumeOperator?: TsComparisonOperator | null;
  notional?: number | null;
  notionalOperator?: TsComparisonOperator | null;
  openTime?: string | null; // YYYY-MM-DDTHH:mm:ss
  closeTime?: string | null;
  equity?: number | null;
  equityOperator?: TsComparisonOperator | null;
  marginLevel?: number | null;
  marginLevelOperator?: TsComparisonOperator | null;
  overnightDays?: number | null;
  reason?: number | null;
  reportingCurrency: boolean;
  marInstruments: boolean;
  mifidClassification?: MiFIDClassification | null;
  countryId?: number | null;
}

// EntityDto<int> list row.
export interface TsAlertTemplateListItemDto {
  id: number;
  profileTag: string;
  enabled: boolean;
  creationTime: string;
  lastModificationTime?: string | null;
}

// Full detail returned by GetAsync, shown in the view modal.
export interface TsAlertTemplateDto {
  id: number;
  profileTag: string;
  typeName?: string | null;
  enabled: boolean;
  priority?: string | null;
  historyDate: string;

  type?: TsAlertProfileType | null;

  tradeSession?: TsTradeSession | null;
  tradeTime?: number | null;
  tradePoints?: number | null;
  openTime?: string | null;
  closeTime?: string | null;

  volume?: number | null;
  volumeOperator?: TsComparisonOperator | null;
  notional?: number | null;
  notionalOperator?: TsComparisonOperator | null;

  cumulativeProfitThresholds: boolean;
  cumulativeProfitThresholdsAmount?: number | null;
  cumulativeProfitThresholdsFloating: boolean;
  cumulativeProfitThresholdsPeriod?: string | null;
  profitThresholdsPerTrade: boolean;
  profitThresholdsAmountPerTrade?: number | null;

  equity?: number | null;
  equityOperator?: TsComparisonOperator | null;
  marginLevel?: number | null;
  marginLevelOperator?: TsComparisonOperator | null;

  overnightDays?: number | null;

  reason?: number | null;
  reportingCurrency: boolean;
  marInstruments: boolean;
  mifidClassification?: MiFIDClassification | null;
  countryId?: number | null;
  countryName?: string | null;

  creationTime: string;
  lastModificationTime?: string | null;
}

// TsProfileFilterDto : PaginatedInputDto (PagedAndSortedResultRequestDto).
export interface TsProfileFilterInput {
  skipCount: number;
  maxResultCount: number;
  sorting?: string;
  draw?: number;
  search?: string;
  profileTag?: string;
}
